import studyHabitsData from './study-habits-content.json';
import type { StudyHabitsContent } from './types';

export * from './types';

export const studyHabitsContent = studyHabitsData as StudyHabitsContent;
